import AsyncComponentRetry from './AsyncComponentRetry.component'

export default AsyncComponentRetry
